module.exports = __webpack_public_path__ + "static/media/ра.e15d9cb8.mp3";